import { ConfigProvider } from "antd";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import Theme from "./theme";
import AppWrapper from "./appWrapper";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <ConfigProvider theme={Theme}>
    <AppWrapper />
  </ConfigProvider>,
);

reportWebVitals();
